import SelectSession from '../../../guidanceSessions/components/SelectSession';

export default function SelectSessionScreen() {
    return <SelectSession />;
}
